import { useParams } from 'react-router-dom';
import Single from '../../components/single/Single';
import './testimony.scss';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useEffect,useState } from 'react';

const Testimony = () => {

    const params = useParams();
    const axiosPrivate = useAxiosPrivate();
    const [testomonyData, setTestimonyData] = useState([]);

    useEffect(() => {
        const getTestimony = async () => {
            try {
                const { data: response } = await axiosPrivate.get(`/testimonials/${params.id}`);
                if(!testomonyData.length){
                    setTestimonyData(response);
                }
                
                console.log(response);
            } catch (error) {
                console.log(error.message);
            }
        }
        getTestimony();
    });

    
    return (
        <div className='testimony'>
            <Single {...testomonyData} />
        </div>
    )
}

export default Testimony